import React from "react";
import { FaCode, FaLaptopCode } from "react-icons/fa";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCertificate } from "@fortawesome/free-solid-svg-icons";

const Experience = () => {
    return (
        <div className="bg-gray-800 text-gray-300 py-12 px-6">
            <h2 className="text-3xl font-bold text-center mb-8">Experience</h2>
            <div className="max-w-4xl mx-auto">
                {/* Experience Item */}
                <div className="bg-gray-900 p-6 rounded-lg shadow-lg mb-6">
                    <div className="flex items-center mb-4">
                        <FaCode className="text-2xl text-teal-400 mr-3" />
                        <h3 className="text-xl font-semibold">Front-End Developer</h3>
                    </div>
                    <p className="text-sm mb-2">
                        <strong>Institute:</strong> Codenectic Academy
                    </p>
                    <p className="text-sm mb-2">
                        <strong>Course Completed:</strong> Full-Stack Development
                    </p>
                    <p className="text-sm mb-4">
                        <strong>Timeline:</strong>  24hr Active
                    </p>
                    <p>
                        As a front-end developer, I focused on crafting responsive and
                        user-friendly interfaces. I have hands-on experience with
                        technologies like React, Tailwind CSS, and modern JavaScript, which
                        empowered me to build seamless web experiences.
                    </p>
                </div>

                {/* Expertise Section */}
                <div className="bg-gray-900 p-6 rounded-lg shadow-lg">
                    <div className="flex items-center mb-4">
                        <FaLaptopCode className="text-2xl text-teal-400 mr-3" />
                        <h3 className="text-xl font-semibold">Expertise & Achievements</h3>
                    </div>
                    <ul className="list-disc pl-5">
                        <li>
                            Built responsive web applications with clean and maintainable
                            code.
                        </li>
                        <li>
                            Proficient in modern front-end libraries like React and
                            frameworks.
                        </li>
                        <li>
                            Completed hands-on projects that improved client workflows and
                            user engagement.
                        </li>
                        <li>
                            Certified by Codenectic Academy in Front-End development.
                            <FontAwesomeIcon
                                icon={faCertificate}
                                className="text-yellow-400 ml-2"
                            />
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default Experience;
